import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Button from '../../../../../../../Form/Button';
import ModalStore from '../../../../../../../Modal/Store';
import IframeContentStore from '../../IframeContent/Store';
import PreviewStore from '../../Store';
import BrowseAll from '../BrowseAll';
import Inputs from './Inputs';
import Sections from './Sections';

interface Props {
  store: PreviewStore;
  iframeContentStore: IframeContentStore;
  learningCollectionDescriptionModalStore: ModalStore;
}

const LearningCollectionForm: React.FC<Props> = ({
  store,
  iframeContentStore,
  learningCollectionDescriptionModalStore,
}) => {
  return (
    <div className="h-full border-x">
      <div className="h-full overflow-auto pb-24">
        <Inputs
          store={store}
          learningCollectionDescriptionModalStore={learningCollectionDescriptionModalStore}
        />
        <Sections store={store} />
        {store.learningCollectionStore.browseAll && (
          <BrowseAll store={store.learningCollectionStore} />
        )}
      </div>
      <div
        className={clsx(
          'flex items-center justify-center bg-white py-4',
          'absolute bottom-0 left-0 right-0 rounded-t border-x',
          'shadow-[0px_0px_12px_rgba(26,26,26,0.1)]',
        )}
      >
        <Button
          type="submit"
          value="Save & Reload Preview"
          onClick={() => {
            iframeContentStore.loading();
            store.learningCollectionStore.previewingUpdating(iframeContentStore, store);
          }}
          disabled={!store.unsavedChanges || store.learningCollectionStore.inPreviewUpdatingState}
          className={clsx('rounded bg-teal-600 px-5 py-2.5 text-sm text-white disabled:opacity-60')}
        />
      </div>
    </div>
  );
};

export default observer(LearningCollectionForm);
